import { BaseContainer } from "@pdf/helpers/container/base-container";
import { ContainerProperties } from "@pdf/pdf-properties";

export class FlexContainer extends BaseContainer {
  constructor(xPosition: number, width: number) {
    super(xPosition, ContainerProperties.Y, width, ContainerProperties.HEIGHT);
  }
}
